// MUTATIONS
export const SET_CATEGORIES = 'setCategories';
export const SET_CURRENT_CATEGORY = 'setCurrentCategory';
export const SET_IS_LOADING = 'isLoading';
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';
export const SET_IS_TEMPLATE = "setIsTemplate";
export const SET_USERS_GROUPS = 'setUsersGroups';

// ACTIONS
export const ACTION_GET_CATEGORIES = 'getCategories';
export const ACTION_CREATE_CATEGORY = "createCategory";
export const ACTION_UPDATE_CATEGORY = "updateCategory";
export const ACTION_REMOVE_CATEGORY = "removeCategory";
export const ACTION_UPDATE_CATEGORY_REQUIRED_TEST_RESULTS = 'updateCategoryRequiredTestResults';
export const ACTION_CLONE_TEMPLATE_CATEGORY = 'cloneTemplateCategory';

// GETTERS
export const GET_CATEGORIES = 'categories';
export const GET_CURRENT_CATEGORY = 'currentCategory';
export const GET_IS_LOADING = 'isLoading';
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';
export const GET_IS_TEMPLATE = "isTemplate";